import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { i18n } from "@/lib/i18n";
import { appShellTitle } from "@/lib/seo/head";

function AuthEmailShell() {
  const { t } = useTranslation();
  return (
    <section>
      <h1 className="text-2xl font-semibold tracking-tight">{t("shells.authEmail")}</h1>
    </section>
  );
}

export const Route = createFileRoute("/auth/email")({
  head: () => ({ meta: [{ title: appShellTitle(i18n.t("shells.authEmail")) }] }),
  component: AuthEmailShell,
});
